var map = {
	"./Airline.jpg": "de1a",
	"./Airport.jpg": "b984",
	"./Analytics.jpg": "8c8c",
	"./Data-pipeline-2.png": "484f",
	"./Data-pipeline-3.png": "d9d0",
	"./Data-pipeline.png": "fcf3",
	"./Management.jpg": "b7c3",
	"./Procurement.jpg": "47bc",
	"./Time-Series.jpg": "95d2",
	"./WSLogo.png": "569f",
	"./about-us.jpg": "98e2",
	"./achievements.jpg": "c044",
	"./bg-1.jpg": "7194",
	"./bg-2.jpg": "e16a",
	"./bg-3.jpg": "ca7f",
	"./businessman.jpg": "6847",
	"./logo.png": "9d64",
	"./thumbnail.png": "4020"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";